import { NgModule } from '@angular/core';
import { BuIconComponent } from './bu-icon/bu-icon.component';

@NgModule({
  imports: [],
  declarations: [BuIconComponent],
  exports: [BuIconComponent]
})
export class BuIconModule { }
